import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { AnimatePresence, motion } from 'framer-motion';
import './HomeProjects.css';

const projects = [
  {
    id: "01",
    tag: "Utility Scale Solar",
    title: "Solar & BESS Project Advisory",
    description: "Supporting technical and execution planning for renewable projects.",
    image: "https://dazbog.ascentbw.com/Images/Home/pro1.png",
    link: "/projects/solar-bess"
  },
  {
    id: "02",
    tag: "Hybrid Renewable Project ",
    title: "Hybrid Solar + BESS Solutions",
    description: "Integrated solar and battery solutions with planning and advisory support",
    image: "https://dazbog.ascentbw.com/Images/Home/pro2.png",
    link: "/projects/wind"
  },
  {
    id: "03",
    tag: "Project Development",
    title: "Renewable Project Site Planning",
    description: "Helping developers with project studies, technical reviews, and site planning support.",
    image: "https://dazbog.ascentbw.com/Images/Home/pro3.png",
    link: "/projects/hydrogen"
  },
  {
    id: "04",
    tag: "Emerging Energy",
    title: "Green Hydrogen & New Energy Projects",
    description: "Supporting future energy initiatives through technical and strategic project advisory.",
    image: "https://dazbog.ascentbw.com/Images/Home/pro4.png",
    link: "/projects/hydrogen"
  }
];

const HomeProjects = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % projects.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % projects.length);
  };

  return (
    <section className="home-projects-section">
      <Container>
        <Row className="align-items-start">
          {/* Left Content */}
          <Col lg={5} className="project-text-col">
            <div className="section-tag">
              Our Project
            </div>
            <h2 className="project-main-heading">
              Delivering Renewable Energy <br /> Projects Across Sectors
            </h2>
            <div className="project-desc-wrap">
              <p className="project-description">
                From solar and BESS projects to technical advisory and project execution, 
                we support renewable energy initiatives from planning to delivery.
              </p>
              
              <div className="project-nav-arrows">
                <button className="nav-btn prev" onClick={handlePrev} aria-label="Previous Project">
                  <FiArrowLeft />
                </button>
                <button className="nav-btn next" onClick={handleNext} aria-label="Next Project">
                  <FiArrowRight />
                </button>
              </div>
            </div>
          </Col>

          {/* Right Image Card */}
          <Col lg={7} className="project-card-col">
            <div className="project-main-card">
              <AnimatePresence mode="wait">
                <motion.div 
                   key={activeIndex}
                   initial={{ opacity: 0, x: 20 }}
                   animate={{ opacity: 1, x: 0 }}
                   exit={{ opacity: 0, x: -20 }}
                   transition={{ duration: 0.5 }}
                   className="project-card-inner"
                >
                  <div className="project-card-image">
                    <img 
                      src={projects[activeIndex].image} 
                      alt={projects[activeIndex].title} 
                    />
                    <div className="card-overlay">
                      <div className="card-content-bottom">
                        <div className="card-tag-wrapper">
                           <span className="card-tag">{projects[activeIndex].tag}</span>
                        </div>
                        <h3 className="card-title2">{projects[activeIndex].title}</h3>
                        <p className="card-desc2">
                          {projects[activeIndex].description}
                        </p>
                        <div className="card-footer">
                          <span className="read-more-link" style={{ cursor: "pointer" }}>
                            Read more <FiArrowRight className="link-icon" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeProjects;
